import { styled } from 'styled-components';

import { BREAKPOINTS } from '@shared/styled-system';

export const RaceTimer = styled.div`
	align-items: center;
	display: flex;
	justify-content: space-between;
	gap: 8px;
	margin-bottom: 12px;

	@media (${BREAKPOINTS.MOBILE}) {
		display: none;
	}
`;

// Mobile timer - simple text under race name
export const MobileTimer = styled.div`
	display: none;
	font-size: 12px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	margin-top: 4px;

	@media (${BREAKPOINTS.MOBILE}) {
		display: block;
	}
`;

export const TimerLabel = styled.div`
	font-size: 13px;
	color: ${({ theme }) => theme.colors.text.subtitle};
	text-align: center;
`;

export const TimerValues = styled.div`
	display: flex;
	justify-content: center;
	gap: 4px;
`;

export const TimerUnit = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
`;

export const TimerValue = styled.div`
	background-color: ${({ theme }) => theme.colors.transparent.light10};
	border-radius: 4px;
	font-size: 12px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	width: 30px;
	height: 30px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const TimerUnitLabel = styled.div`
	font-size: 10px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	margin-top: 2px;
`;

export const TimerSeparator = styled.div`
	font-size: 14px;
	font-weight: 500;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	margin-top: 2px;
`;
